import React from "react";
import PropTypes from "prop-types";

import { Checkbox, FormControlLabel } from "@mui/material";

const ApprovalCheckbox = ({ event, onChange }) => {

  const showInSingleEvents = event?.single && event?.tickets?.some(ticket => !ticket.sellable);

  const showInExistingRecurrentEvents = !event?.single && event?.id && event?.sessions?.some(session => session.tickets.some(ticket => !ticket.sellable));

  const showInNewRecurrentEvents = !event?.single && !event?.id;

  const show = showInSingleEvents || showInExistingRecurrentEvents || showInNewRecurrentEvents;
  if (!show) return null;
  
  const handleCheckBox = ({ target: { checked } }) => {
    onChange({ target: { name: "requires_approval", value: checked } });
  };

  return (
    <FormControlLabel
      control={
        <Checkbox checked={event.requires_approval} onChange={handleCheckBox} />
      }
      label="Check this box if you want to be able to approve free tickets before they are sent to the user."
    />
  );
};

ApprovalCheckbox.propTypes = {
  event: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ApprovalCheckbox;
